export default __webpack_public_path__ + "static/media/Wall_Door_Left_Grey.256.9b3806bf.png";